import autoSizeColumns from "./AGGridAutoSizeCols";

export default function AGGridIdSearch(onHasId, autoSizeCols = true) {
  return {
    getRowId: (params) => params.data.id.toString(),
    onGridReady: (params) => {
      if (autoSizeCols) autoSizeColumns(params, null);
      const id = new URLSearchParams(window.location.search).get("id")
      if (id) {
        const node = params.api.getRowNode(id);
        if (node) onHasId(node.data);
      }
    }
  }
}